import { attribute } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { EmployeeRoleEnum } from '../enums/employee-role.enum';
import { EmployeeStatusEnum } from '../enums/employee-status.enum';
import { property } from '@pristine-ts/metadata';

export class EmployeeModel {
  @attribute()
  @property()
  id: string;
  @attribute()
  @property()
  email: string;
  @attribute()
  @property()
  role: EmployeeRoleEnum;
  @attribute()
  @property()
  userId: string;
  @attribute()
  @property()
  status: EmployeeStatusEnum;
}
